const SEARCH_USERS_REQUEST = 'SEND_SEARCH_REQUEST';
const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
const SEARCH_FAILURE = 'SEARCH_FAILURE';

export {
    SEARCH_USERS_REQUEST,
    SEARCH_SUCCESS,
    SEARCH_FAILURE
};
  